import { useIntl } from 'react-intl';
import { useMutation } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { queryClient } from 'src/config';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

type ReinstateContractParamsType =
  | { projectTypeCode: 'short_term'; jobApplicationUuid: string }
  | { projectTypeCode: 'long_term'; uuid: string };

const reinstateContract = async (params: ReinstateContractParamsType) => {
  if (params.projectTypeCode === 'short_term') {
    return await putRequest<RequestSimplifiedData>(
      API.PUT.reinstatePhysicalShortTermContract(params.jobApplicationUuid),
      null,
      { headers: { Accept: 'application/vnd.falcon.v3+json' } },
    );
  }

  return await putRequest<RequestSimplifiedData>(
    API.PUT.reinstatePhysicalContract(params.uuid),
    null,
    { headers: { Accept: 'application/vnd.falcon.v2+json' } },
  );
};

export const useReinstateContract = () => {
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: reinstateContract,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.reinstateSuccess));
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.CONTRACTS],
      });
    },
    onError: handleError,
  });
};
